import { render, staticRenderFns } from "./ContestInside.vue?vue&type=template&id=00ad98d2&scoped=true"
import script from "./ContestInside.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestInside.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContestInside.vue?vue&type=style&index=0&id=00ad98d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad98d2",
  null
  
)

export default component.exports